import React, { useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const DownloadPdf = () => {
    const { audit_id } = useParams(); // Get the audit_id from the URL

    useEffect(() => {
        // Fetch the PDF when the component mounts
        const fetchAndDownloadPdf = async () => {
            try {
                const blobName = `downloadedPdf/${audit_id}.pdf`;

                const response = await axios.get('/process_data/fetch-pdf', {
                    params: { blobName },
                    responseType: 'blob' 
                });
                console.log("18", response);

                // Create a blob URL and trigger the download
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                console.log(blob);
                console.log(url);
                // Create a temporary <a> element to programmatically click and trigger download
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${audit_id}.pdf`); // Set the file name for download
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); // Clean up after download

                window.open(url, '_self')

            } catch (error) {
                console.error('Error fetching and downloading PDF:', error);
            }
        };

        fetchAndDownloadPdf();
    }, [audit_id]); 

    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
            fontSize: "1.2rem",
            fontWeight: "bold",
            color: "#28a745",
        }}>
            <span>Downloading...</span>
        </div>
    );
};

export default DownloadPdf;
